import { useEffect, useState } from "react";
import type { ConnectionState } from "../lib/styxClient";

export function useReconnectOverlay(conn: ConnectionState): boolean {
  const [reconnectOverlay, setReconnectOverlay] = useState(false);

  useEffect(() => {
    if (conn !== "closed") {
      setReconnectOverlay(false);
      return;
    }
    const id = window.setTimeout(() => setReconnectOverlay(true), 1800);
    return () => window.clearTimeout(id);
  }, [conn]);

  return reconnectOverlay;
}
